import { Helmet } from 'react-helmet-async';

import { PermissionRequestView } from 'src/sections/system/permissions';
import SystemPageDebugAccess from 'src/sections/system/debug/SystemPageDebugAccess';

// ----------------------------------------------------------------------

export default function PermissionRequestPage() {
  return (
    <>
      <Helmet>
        <title>Permissions Required | PointCraft</title>
      </Helmet>

      <SystemPageDebugAccess />
      <PermissionRequestView />
    </>
  );
}
